// Apply per-page SEO meta tags (title, description, robots) at runtime.
// Called from every public route (PackageDetail, BlogDetail, LandingPageView,
// StaticPageView, Home, BlogList). All fields fall back to sensible defaults.
//
// Usage:
//   useEffect(() => applyPageSEO({ title, description, noIndex, noFollow }), [deps]);
export const applyPageSEO = ({ title, description, noIndex = false, noFollow = false }) => {
  if (title) document.title = `${title} | Travelsera`;
  const setMeta = (name, content) => {
    let m = document.querySelector(`meta[name="${name}"]`);
    if (!m) {
      m = document.createElement('meta');
      m.setAttribute('name', name);
      document.head.appendChild(m);
    }
    m.setAttribute('content', content);
  };
  if (description) setMeta('description', String(description).slice(0, 200));
  const robots = [];
  robots.push(noIndex ? 'noindex' : 'index');
  robots.push(noFollow ? 'nofollow' : 'follow');
  setMeta('robots', robots.join(', '));
  return () => {
    document.title = 'Travelsera - Journeys, Redefined';
    setMeta('robots', 'index, follow');
  };
};
